import { useNavigate } from 'react-router-dom';

interface CategoryPanelProps {
  path: string;
  kicker: string;
  title: string;
  description: string;
  cta: string;
  icon: string;
  image: string;
  alt: string;
}

export default function CategoryPanel({
  path,
  kicker,
  title,
  description,
  cta,
  icon,
  image,
  alt,
}: CategoryPanelProps) {
  const navigate = useNavigate();

  const go = () => {
    navigate(path);
    window.scrollTo({ top: 0 });
  };

  return (
    <button
      onClick={go}
      aria-label={title}
      className="welcome-panel group relative flex-1 min-h-[52vh] lg:min-h-screen overflow-hidden text-left cursor-pointer"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src={image}
          alt={alt}
          title={title}
          className="w-full h-full object-cover object-center transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/75 transition-opacity duration-700 group-hover:opacity-90"></div>

      <div className="relative z-10 flex flex-col items-center justify-end lg:justify-center h-full w-full px-6 md:px-10 pt-40 pb-14 lg:py-24 text-center">
        <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white/10 border border-white/25 backdrop-blur-sm mb-5 md:mb-8 transition-colors duration-500 group-hover:bg-primary-500/25 group-hover:border-primary-400/50">
          <i className={`${icon} text-white text-2xl md:text-3xl`}></i>
        </span>

        <p className="font-label text-[10px] md:text-xs tracking-extra-wide text-primary-400 font-medium uppercase mb-3 md:mb-4">
          {kicker}
        </p>
        <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl font-light text-white tracking-wide mb-4 md:mb-5">
          {title}
        </h2>
        <p className="font-body text-sm md:text-base text-white/70 max-w-xs md:max-w-sm leading-relaxed mb-7 md:mb-10">
          {description}
        </p>

        <span className="inline-flex items-center justify-center gap-2 w-full max-w-xs sm:w-auto px-8 py-4 sm:py-3 bg-primary-500 group-hover:bg-primary-600 text-background-950 text-sm sm:text-xs font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap rounded-md sm:rounded-sm">
          {cta}
          <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
        </span>
      </div>
    </button>
  );
}